import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { isObject, pickBy, toLower } from 'lodash';

const { log } = console;

const sanitizeObject = (object) => {
  const sanitizer = (toSanitize) => {
    const keysToIgnore = [
      'authorization',
      'x-pg-token',
      'pg-token',
      'token',
      'authtoken',
      'temptag',
      'password',
      'resetCode',
    ];
    return pickBy(toSanitize, (value, key) => {
      if (keysToIgnore.indexOf(toLower(key)) <= -1) {
        return value;
      }
      return null;
    });
  };
  if (!isObject(object)) return {};
  const reqResObj = { ...object };
  reqResObj.headers =
    isObject(reqResObj.headers) && sanitizer(reqResObj.headers);
  if (isObject(reqResObj.body)) {
    reqResObj.body = sanitizer(reqResObj.body);
  }
  return reqResObj;
};

const LogRocketEvent = {
  initialize: () => {
    try {
      if (process.env.NODE_ENV === 'production') {
        LogRocket.init(process.env.REACT_APP_LOGROCKET_APP_ID, {
          network: {
            requestSanitizer: (request) => sanitizeObject(request),
            responseSanitizer: (response) => sanitizeObject(response),
          },
        });
        setupLogRocketReact(LogRocket);
      }
    } catch (e) {
      log('Error in LogRocket initialization --- ', e.message);
    }
  },

  identify: ({ companyId, userId }) => {
    LogRocket.identify(userId, {
      companyId,
      domainString: window.location.host,
    });
  },
};

export default LogRocketEvent;



// WEBPACK FOOTER //
// ./src/client/services/LogRocket/index.js